import React, { useEffect, useState } from 'react';
import { Button, Select, InputLabel, Dialog, DialogContent, DialogTitle } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

const ActionModal = ({ actions, closeModal, title, open, row }) => {
    const [selectedAction, setSelectedAction] = useState('');
    useEffect(() => {
        if (!open) {
            handleClose();
        }
    }, [open]);

    const handleActionChange = (event) => {
        const selectedValue = event.target.value;
        const action = actions.find((a) => a.value === selectedValue);
        setSelectedAction(action);
    };

    const handleClose = () => {
        setSelectedAction('');
        closeModal();
    };

    // Determine if we need a larger dialog for certain actions
    const needsLargeDialog = selectedAction?.value === 'bulkMovePallets';

    return (
        <Dialog 
            open={open} 
            maxWidth={needsLargeDialog ? "md" : "sm"} 
            fullWidth={true} 
            onClose={handleClose}
            PaperProps={{
                style: needsLargeDialog ? {
                    minHeight: '600px',
                    maxHeight: '90vh',
                    height: '80vh'
                } : {}
            }}
        >
            <DialogTitle>
                {title}
                <div style={{ float: 'right' }}>
                    <Button onClick={handleClose}>
                        <CloseIcon />
                    </Button>
                </div>
            </DialogTitle>
            <DialogContent style={{ 
                padding: needsLargeDialog ? 0 : undefined,
                overflow: 'hidden',
                display: needsLargeDialog ? 'flex' : 'block',
                flexDirection: 'column'
            }}>
                <div style={{ padding: needsLargeDialog ? '16px' : 0 }}>
                    <InputLabel shrink={true}>Option</InputLabel>
                    <Select native className="input-element-select" onChange={handleActionChange}>
                        <option key="ps" value="ps">
                            Please Select
                        </option>
                        {actions.map((item) => (
                            <option key={item.value} value={item.value}>
                                {item.text}
                            </option>
                        ))}
                    </Select>
                </div>
                <div style={{ 
                    marginTop: '16px',
                    flex: 1,
                    minHeight: needsLargeDialog ? '400px' : 'auto',
                    overflow: needsLargeDialog ? 'hidden' : 'auto'
                }}>
                    {selectedAction?.componentJSX && selectedAction.componentJSX()}
                </div>
            </DialogContent>
        </Dialog>
    );
};

export { ActionModal };
